module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/carousel_arrow-ef604aeec58db1913772c31d6ace24a9.svg";